{
  "api-enums-quoted": "Cotado",
  "api-enums-hired": "Contratado",
  "api-enums-simulated": "Simulado",
  "api-enums-to-be-renewed": "Renovação Futura",
  "api-enums-settled": "Liquidado",
  "api-enums-purchase": "Compra",
  "api-enums-sale": "Comprar",
  "api-enums-import": "Importar",
  "api-enums-export": "Exportar",
  "api-enums-loan4131": "Repasse Externo (4131)",
  "api-enums-foreign_repass": "",
  "api-enums-indicative": "",
  "api-enums-open": "En abierto",
  "api-enums-loan": "préstamo",
  "api-enums-credit-acquisition-acc": "Adiantamento sobre Contrato de Câmbio",
  "api-enums-credit-acquisition-ace": "Adiantamento sobre Cambiais Entregues",
  "api-enums-credit-acquisition-cdc": "CDC",
  "api-enums-credit-acquisition-ccb": "CCB",
  "api-enums-credit-acquisition-cce": "CCE",
  "api-enums-credit-acquisition-bndes": "BNDES",
  "api-enums-credit-acquisition-working-capital": "Capital de Giro",
  "api-enums-credit-acquisition-automaker-cdc": "CDC Automóvel",
  "api-enums-credit-acquisition-finimp": "Finimp",
  "api-enums-credit-acquisition-leasing": "Leasing",
  "api-enums-credit-acquisition-mutuo": "Mutuo",
  "api-enums-credit-acquisition-export-credit-note": "Nota de Crédito Exportação",
  "api-enums-credit-acquisition-external-transfer": "Transferência Externa",
  "api-enums-credit-acquisition-pre-export-payment": "Pagamento Antecipado Exportação",
  "api-enums-export-hedge": "Hedge Exportação",
  "api-enums-import-hedge": "Hedge Importação",
  "api-enums-low": "Bajo",
  "api-enums-medium": "Medio",
  "api-enums-high": "Alto",
  "api-enums-in-progress": "En Progreso",
  "api-enums-completed": "Completado",
  "api-enums-not-started": "",
  "api-enums-open1": "Abierto pendiente",
  "api-enums-overdue": "atrasado",
  "api-enums-foreign-repass": "Retransferencia Externa (4131)",
  "api-enums-loan-operation-type-foreign-repass": "",
  "api-enums-loan-operation-type-ace": "",
  "api-enums-loan-operation-type-acc": "",
  "api-enums-loan-operation-type-bndes": "",
  "api-enums-loan-operation-type-working-capital": "",
  "api-enums-loan-operation-type-manufacturer-financing": "",
  "api-enums-loan-operation-type-direct-consumer-credit": "",
  "api-enums-loan-operation-type-bank-credit-note": "",
  "api-enums-loan-operation-type-export-credit-ballot": "",
  "api-enums-loan-operation-type-finimp": "",
  "api-enums-loan-operation-type-leasing": "",
  "api-enums-loan-operation-type-loan": "",
  "api-enums-loan-operation-type-export-credit-note": "",
  "api-enums-loan-operation-type-export-prepayment": "",
  "api-enums-bank-manager-position-general-manager": "Gerente General",
  "api-enums-bank-manager-position-relationship-manager": "Gerente de Relaciones",
  "api-enums-bank-manager-position-business-manager": "Gerente de Negocios",
  "api-enums-bank-manager-position-corporate-manager": "Gerente Corporativo",
  "api-enums-bank-manager-position-commercial-officer": "Oficial Comercial",
  "api-enums-bank-manager-position-assistant-manager": "Gerente Asistente",
  "api-enums-bank-manager-position-client-specialist": "Especialista de Clientes",
  "api-enums-bank-manager-position-credit-analyst": "Analista de Crédito",
  "api-enums-bank-manager-position-credit-desk": "Mesa de Crédito",
  "api-enums-bank-manager-position-derivatives-desk": "Mesa de Derivados",
  "api-enums-bank-manager-position-trader": "Trader",
  "api-enums-bank-manager-position-risk-analyst": "Analista de Riesgo",
  "api-enums-bank-manager-position-risk-manager": "Gerente de Riesgo",
  "api-enums-bank-manager-position-other": "Otro",
  "api-enums-within-band": "Dentro de la Banda",
  "api-enums-attention": "Atención",
  "api-enums-action-needed": "Acción Necesaria",
  "api-enums-risk-event": "Evento de Riesgo",
  "api-enums-committee-decision": "Decisión del Comité",
  "auth-welcome-message": "¡Bienvenido!",
  "auth-login-prompt": "Inicia sesión para comenzar.",
  "auth-field-email": "Correo electrónico",
  "auth-field-password": "Contraseña",
  "auth-field-password-confirmation": "Confirme la contraseña",
  "auth-at-least8-characters": "Al menos 8 carácteres",
  "auth-at-least1-capital-letter": "Al menos 1 letra mayúscula (A-Z)",
  "auth-at-least1-number": "Al menos 1 número (0-9)",
  "auth-at-least1-symbol": "Al menos un símbolo (#$&)",
  "auth-to-define": "Definir",
  "auth-remember-password-message": "Recordar contraseña en este dispositivo",
  "auth-sigin-button": "Iniciar sesión",
  "auth-last-password-label": "¿Olvidaste tu contraseña?",
  "auth-first-access-label-q": "¿Primer acceso?",
  "auth-first-access-label": "Primer acceso",
  "auth-define-password-to-access": "Establezca su contraseña para acceder al sistema Vault",
  "auth-login-validating-credentials": "Validando credenciales...",
  "auth-login-auth-success": "¡Autenticación exitosa!",
  "auth-login-getting-permissions": "Obteniendo permisos...",
  "auth-invalid-token-title": "Token inválido",
  "auth-invalid-token-message": "El token recibido durante la autenticación no es válido.",
  "auth-access-token-renewed-title": "Acceso renovado",
  "auth-access-token-renewed-success": "Token de autenticación renovado con éxito",
  "auth-access-token-renewed-error": "Hubo un error al renovar el token de acceso, por favor inicia sesión nuevamente",
  "auth-access-token-renewal-in-progress": "Tu token de acceso está a punto de expirar, renovación automática en progreso",
  "auth-access-token-renewal-title": "Renovación de acceso",
  "auth-recover-password-title": "Recuperación de contraseña",
  "auth-recover-password-success": "Si la dirección de correo electrónico proporcionada es correcta, recibirás en breve un enlace para crear una nueva contraseña",
  "auth-recover-password-instructions": "Ingresa tu correo electrónico para recibir instrucciones",
  "auth-password-created-successfully": "Contraseña creada con éxito",
  "auth-password-updated-successfully": "Contraseña actualizada con éxito",
  "auth-error-creating-password": "Error al crear la contraseña",
  "auth-error-updating-password": "Error al actualizar la contraseña",
  "auth-error-login": "Correo electrónico o contraseña no válidos",
  "auth-confirm-send-password-recovery-email": "¿Está seguro de que desea enviar el correo electrónico de recuperación de contraseña al usuario?",
  "auth-password-recovery-link1": "Enlace para la recuperación de contraseña",
  "auth-additional-costs": "Costos adicionales",
  "calendar-january": "Enero",
  "calendar-february": "Febrero",
  "calendar-march": "Marzo",
  "calendar-april": "Abril",
  "calendar-may": "Mayo",
  "calendar-june": "Junio",
  "calendar-july": "Julio",
  "calendar-august": "Agosto",
  "calendar-september": "Septiembre",
  "calendar-october": "Octubre",
  "calendar-november": "Noviembre",
  "calendar-december": "Diciembre",
  "calendar-confirm-cancel": "¿Está seguro de que desea cancelar?",
  "calendar-create": "Crear",
  "comex-comex-control": "Comex",
  "comex-number-of-operations": "Número de operaciones",
  "comex-percentage-of-down-payments-made": "Porcentaje de Pagos Iniciales realizados",
  "comex-average-cost-of-lcs": "Costo promedio de las LCs",
  "comex-comex-operations": "Operaciones Comex",
  "comex-error-loading-kpis": "Error al Cargar los KPIs",
  "comex-error-loading-comex-operations": "Error al cargar operaciones de comex",
  "comex-operation-updated-successfully1": "Operación Actualizada Con Éxito",
  "comex-error-updating-operation1": "Error Actualizando Operación",
  "comex-operation-created-successfully1": "Operación creada con éxito",
  "comex-error-creating-operation1": "Error Creando Operación",
  "comex-stage-saved-successfully": "Etapa guardada con éxito",
  "comex-error-saving-step": "Error al guardar etapa",
  "comex-reference1": "Referencia",
  "comex-supplier": "Proveedor",
  "comex-fob-value": "Valor del Fob",
  "comex-tax-value": "Valor del Impuesto",
  "comex-freight-value": "Valor del Flete",
  "comex-foreign-currency-value": "Valor en moneda extranjera",
  "comex-comex-registration": "Registro Comex",
  "comex-negotiation-and-formalization": "Negociación y Formalización",
  "comex-financial-execution": "Ejecución Financiera",
  "comex-down-payment": "Pago inicial",
  "comex-percentage": "Porcentaje",
  "comex-tax1": "Tasa",
  "comex-term": "Término",
  "comex-flow1": "flujo",
  "comex-payment-condition": "Condición de Pago",
  "comex-data-down-payment": "Pago Inicial de Datos",
  "comex-bank-down-payment": "Pago Inicial del Banco",
  "comex-data-de-atracacao": "Fecha de Atraque",
  "comex-shipping-date": "Fecha de Embarque",
  "comex-load-forecast": "Pronóstico de Carga",
  "comex-real-value": "Valor Real",
  "comex-due-date-lc": "Fecha de Vencimiento de la LC",
  "comex-lc-value": "Valor de la LC",
  "comex-data-emissao": "Fecha de Emisión",
  "comex-banco-lc": "Banco LC",
  "comex-payment-lc": "Pago LC",
  "comex-real-cost-lc": "Costo Real LC",
  "comex-annual-cost-flat-lc": "Costo Anual LC Flat",
  "comex-attachment-lc": "Adjunto LC",
  "comex-save-operation-first": "Guardar la Operación Primero",
  "comex-hedge-contratado": "Hedge Contratado",
  "comex-waiting-for-production": "Esperando por Producción",
  "comex-in-production": "En Producción",
  "comex-awaiting-boarding": "Esperando Embarque",
  "comex-in-transit": "En Tránsito",
  "comex-registered1": "Registrado",
  "comex-completed1": "Finalizado",
  "comex-canceled": "Cancelado",
  "comex-save-step": "Guardar parcialmente",
  "comex-budget-rate2": "Tasa de Presupuesto",
  "comex-enter": "Escribe...",
  "comex-save-data-confirmation": "¿Desea guardar los datos llenados hasta ahora? Podrá retomar el llenado más tarde.",
  "comex-save-partial-form": "Guardar Formulario Parcial",
  "comex-mandatory-fields-needs-to-be-filled": "Por favor, complete todos los campos obligatorios de la negociación y formalización",
  "comex-mandatory-fields-financial-execution": "Por favor, complete todos los campos obligatorios de la ejecución financiera",
  "comex-required-fields-letter-of-credit": "Por favor, complete todos los campos requeridos de la LC (Carta de Crédito)",
  "comex-partially-saved-successfully": "Guardado parcialmente con éxito",
  "comex-real-value1": "Valor real",
  "comex-load-readiness": "Listo para Cargar",
  "comex-data-loss-warning1": "Todos los datos ingresados se perderán si no los ha guardado parcialmente.",
  "comex-inform-currency": "Informe la Moneda",
  "comex-aprazo": "A Tiempo",
  "comex-at-sight": "A la Vista",
  "comex-load-forecast1": "Pronóstico de Carga",
  "comex-payment-date": "Fecha de Pago",
  "comex-payment-bank": "Banco de Pago",
  "comex-add-payment": "Agregar Pago",
  "comex-payment-installment": "Pago a plazos",
  "comex-confirm-deletion": "Confirmar Eliminación",
  "comex-operation-confirm-delete": "Al confirmar, esta operación será eliminada permanentemente. ¿Desea continuar?",
  "comex-operation-deleted-successfully": "Operación eliminada con éxito",
  "comex-negotiation": "Negociación",
  "comex-delete1": "Eliminar",
  "comex-error-deleting-operation": "Error al Eliminar la Operación",
  "comex-download-attachment": "Descargar Adjunto",
  "comex-invoice": "Factura",
  "comex-ref-trading": "Ref. Comercio",
  "comex-early": "anticipado",
  "comex-expiration-date": "Fecha de Vencimiento",
  "comex-attention": "Atención",
  "comex-negotiation-data-required": "Los datos de la negociación son obligatorios",
  "comex-negotiation-attachments": "Adjuntos de la negociación",
  "comex-bank-reference": "",
  "comex-bank-reference1": "Referencia del Banco",
  "comex-purchase-order": "Orden de Compra (OC)",
  "comex-total-value": "Valor Total",
  "comex-status-parcela": "Estado de la Cuota",
  "comex-average-payment-term": "Plazo medio de pago",
  "comex-comment": "Comentario",
  "comex-order-date": "Fecha de la Orden",
  "comex-container-quantity": "Cantidad de Contenedores",
  "comex-release-date": "Fecha de lanzamiento",
  "comex-release-time": "Tiempo de liberación",
  "comex-annual-cost1": "Costo anual",
  "comex-flat-cost": "Costo Plano",
  "comex-are-you-sure-you-want-to-exit": "¿Está seguro de que desea salir?",
  "comex-flat-opening-commission-rate": "Tarifa de Comisión de Apertura Flat",
  "comex-opening-commission-rate-per-year": "Tasa de Comisión de Apertura por Año",
  "comex-comex-operation": "Operación de Comex",
  "comex-no-comex-operation-found": "Ninguna operación de comex encontrada",
  "comex-product-value": "Valor del producto",
  "comex-bus-station": "estación de autobuses",
  "comex-aereo": "Aéreo",
  "comex-maritime-lcl": "Marítimo LCL",
  "comex-maritimo-fcl": "Marítimo FCL",
  "control-currency-control": "Control de cambio",
  "control-official-exchange-rate": "Tipo de Cambio Oficial",
  "control-exchange-control": "Control de Cambio",
  "control-exchange-rates": "Tasas de Cambio",
  "control-select-coins": "Seleccione las Monedas",
  "control-recorded-operations": "Operaciones Registradas",
  "control-no-registered-operations": "No Hay Operaciones Registradas",
  "control-currency-registration": "Registro de Divisas",
  "control-bank-ag-and-company-account": "Banco, AG y cuenta de la empresa",
  "control-operation-date": "Fecha de operación",
  "control-operation-type2": "Tipo de operación",
  "control-foreign-payer-receiver-bank": "Banco pagador/recetor exterior",
  "control-national-payer-receiver-bank": "Banco pagador/receptor nacional",
  "control-payer-recipient-country-abroad": "País pagador/receptor en el extranjero",
  "control-exchange-closed": "cambio cerrado",
  "control-delivery-date-of-exchange": "Fecha de entrega del cambio",
  "control-foreign-currency-amount": "Cantidad de moneda extranjera",
  "control-exchange-edited-successfully": "¡Intercambio editado con éxito!",
  "control-exchange-registered-successfully": "¡Intercambio registrado exitosamente!",
  "control-file-deleted-successfully": "¡Archivo eliminado con éxito!",
  "control-operation-successfully-deleted": "¡Operación eliminada con éxito!",
  "control-remove-exchange-operation": "Eliminar Operación de Cambio",
  "control-confirm-delete-operation": "¿Estás seguro de que deseas eliminar esta operación?",
  "control-data-operation": "Fecha de Operación",
  "control-foreign-currency-value1": "Valor en Moneda Extranjera",
  "control-valor-me": "Valor M.E.",
  "control-exchange-closed1": "Cambio Cerrado",
  "control-exchange-rate-closed": "Tasa de Cambio Cerrada",
  "control-converted-value": "Valor Convertido",
  "control-converted-value-in-national-currency": "Valor Convertido en Moneda Nacional",
  "control-total-in-national-currency": "Total en Moneda Nacional",
  "control-delivery-date-currency": "Fecha de Entrega Moneda",
  "control-delivery-date-of-exchange1": "Fecha de Entrega del Cambio",
  "control-foreign-bank": "Banco en el Extranjero",
  "control-payer-or-receiver-bank-abroad": "Banco Pagador o Receptor en el Extranjero",
  "control-payer-or-receiver-in-foreign-country": "Pagador o Receptor en el Extranjero",
  "control-operation-type3": "Tipo de Operación",
  "control-beneficiary": "Beneficiario",
  "control-installment1": "Cuota",
  "control-loan-number-contract": "Número de Préstamo (contrato)",
  "control-no-loan-found": "No se encontraron préstamos",
  "control-no-installment-found": "Ninguna cuota encontrada",
  "costs-actions": "",
  "costs-biological-asset": "",
  "costs-guarantee": "",
  "costs-guarantees": "Garantías",
  "costs-checks": "",
  "costs-customer-contract": "",
  "costs-duplicates": "",
  "costs-financial-applications": "",
  "costs-equipment": "",
  "costs-bank-guarantee": "",
  "costs-receivables-flow": "",
  "costs-real-estate": "",
  "costs-raw-material": "",
  "costs-promissory-note": "",
  "costs-credit-card-receivables": "",
  "costs-lease-guarantee": "",
  "costs-surety-bond": "",
  "costs-vehicles": "",
  "costs-inventory": "",
  "costs-warrant": "Warrant",
  "costs-others": "",
  "costs-remove-warranty": "Eliminar garantía",
  "costs-confirm-delete-warranty": "¿Está seguro de que desea eliminar esta garantía?",
  "costs-guarantee-excluded-successfully": "Garantía excluida con éxito",
  "costs-warranty-management": "Gestión de garantías",
  "costs-register-warranty": "Registrar Garantía",
  "costs-no-registered-warranty": "Ninguna Garantía Registrada",
  "costs-all-warranties": "Todas las Garantías",
  "costs-list-of-guarantees": "Lista de garantías",
  "costs-add-warranties": "Agregar Garantías",
  "costs-reference-name": "Nombre de referencia",
  "costs-add-name-to-guarantee": "Agregar un nombre a la garantía",
  "costs-last-evaluation-date": "Fecha de la última evaluación",
  "costs-guarantee-edited-successfully": "¡Garantía editada con éxito!",
  "costs-guarantee-registered-successfully": "¡Garantía registrada con éxito!",
  "costs-number-of-installments1": "",
  "costs-number-of-instalments": "Número de Cuotas",
  "costs-ace": "Anticipo sobre Contratos de Cambio Entregados",
  "costs-acc": "Anticipo sobre Contrato de Cambio",
  "costs-bndes": "Banco Nacional de Desarrollo Económico y Social",
  "costs-working-capital": "Capital de Trabajo",
  "costs-manufacturer-financing": "CDC del Fabricante",
  "costs-direct-consumer-credit": "Crédito Directo al Consumidor",
  "costs-bank-credit-note": "Nota de Crédito Bancaria",
  "costs-export-credit-ballot": "Nota de Crédito de Exportación",
  "costs-finimp": "Financiamiento para Importación",
  "costs-leasing": "Arrendamiento",
  "costs-loan": "Préstamo",
  "costs-export-credit-note": "Nota de Crédito de Exportación",
  "costs-foreign-repass": "Reasignación Externa",
  "costs-export-prepayment": "Prepago de Exportación",
  "costs-commercial-note": "Nota Comercial",
  "costs-fixed-rate": "Fixed Rate",
  "costs-percent-of-libor": "% LIBOR",
  "costs-percent-of-sofr": "% SOFR",
  "costs-percent-of-euribor": "% EURIBOR",
  "costs-liborplus-spread": "",
  "costs-sofrplus-spread": "",
  "costs-euriborplus-spread": "",
  "costs-tjlp": "TJLP",
  "costs-tlp": "TLP",
  "costs-tfb": "TFB",
  "costs-selic-plus-rate": "Selic + Rate",
  "costs-pre": "PRE",
  "costs-cdiplus-rate": "CDI + Rate",
  "costs-percent-of-cdi": "% CDI",
  "costs-percent-of-selic": "% Selic",
  "costs-loans": "Préstamos",
  "costs-currency-variation": "Variación Cambial (VC)",
  "costs-loan-details": "Detalles del Préstamo",
  "costs-settle-instalment": "Liquidar Cuota",
  "costs-manage-derivatives": "Gestionar Derivados",
  "costs-link-derivative": "Vincular Derivativo",
  "costs-revert": "Revertir",
  "costs-cannot-reverse-unsettled-installment": "No es posible revertir una cuota que no está liquidada",
  "costs-revert-payment": "Revertir Pago",
  "costs-reverse-payment-installment": "¿Desea revertir el pago de la cuota?",
  "costs-payment-reverted-successfully": "Pago revertido con éxito!",
  "costs-unable-to-reverse-unpaid-instalment": "No es posible revertir una cuota que no está pagada.",
  "costs-no-data-available": "Sin datos disponibles",
  "costs-no-results-found": "No se encontraron resultados",
  "costs-entries": "Entradas",
  "costs-last-payment": "Último pago",
  "costs-total-installments": "Total de las cuotas",
  "costs-loan-types": "Tipos de préstamo",
  "costs-credit-value": "Valor del crédito",
  "costs-credit-in-national-currency": "Crédito en moneda nacional",
  "costs-outstanding-balance-in-local-currency": "Saldo deudor en moneda local",
  "costs-last-installment-due-date-start": "Fecha de vencimiento de la última cuota (inicio)",
  "costs-last-installment-due-date-end": "Fecha de vencimiento de la última cuota (fin)",
  "costs-working-capital1": "Capital de Trabajo",
  "derivatives-settled-transactions": "Operaciones Liquidadas",
  "derivatives-hedge-position": "Posición de Cobertura",
  "derivatives-report-error-title": "Error al generar el informe, inténtalo de nuevo.",
  "derivatives-report-error-description": "Si el error persiste, ponte en contacto con el soporte.",
  "derivatives-report-error-btn-suport": "Soporte",
  "derivatives-report-error-btn-try-again": "Intentar Nuevamente",
  "derivatives-report-success-title": "¡Informe generado con éxito!",
  "derivatives-report-success-description": "Tu informe ha sido descargado automáticamente. Encuéntralo en la carpeta de Descargas o en el lugar elegido.",
  "derivatives-budget-rate": "",
  "derivatives-exchange-rate-exposure": "",
  "derivatives-exposure-currency": "",
  "document-padronization-document-padronization": "Estandarización de Documentos",
  "document-padronization-notional1": "Notional",
  "effective-exchange-rate-select-at-least-one-request": "Seleccione al menos una solicitud para ver la información",
  "effective-exchange-rate-currency-effectiveness": "Tipo de Cambio Efectivo",
  "effective-exchange-rate-hedges": "Cercas",
  "effective-exchange-rate-currency-closure": "Cierre de Moneda",
  "effective-exchange-rate-cash-flow1": "Flujo de caja",
  "effective-exchange-rate-hedge-order": "Orden de Cobertura",
  "effective-exchange-rate-deadline-days1": "Plazo (Días)",
  "effective-exchange-rate-price-ndf1": "Precio (NDF)",
  "effective-exchange-rate-cap-do-ndf": "CAP del NDF",
  "effective-exchange-rate-ptax-reversal": "PTAX/Reversión",
  "effective-exchange-rate-exchange-rate-effective-calculated": "Var. Tasa de Cambio Efectiva (Calculada)",
  "effective-exchange-rate-hedge-effective-exchange": "Cambio Efectivo de Hedge",
  "effective-exchange-rate-exchange2": "Cambio",
  "effective-exchange-rate-priced-exchange": "Cambio Precificado",
  "effective-exchange-rate-cash-flow2": "Flujo de Caja",
  "effective-exchange-rate-effective-date": "Fecha Efectiva",
  "effective-exchange-rate-value-me": "Valor ME",
  "effective-exchange-rate-order-event": "Orden Evento",
  "effective-exchange-rate-data-contract": "Contrato de Datos.",
  "effective-exchange-rate-settlement-date1": "Fecha de liquidación",
  "effective-exchange-rate-exchange-budget": "Presupuesto de Cambio",
  "effective-exchange-rate-accumulated-balance": "Saldo Acumulado",
  "general-open": "Abrir",
  "general-opened": "Aberto",
  "general-close": "Fechar",
  "general-closed": "Fechado",
  "general-submit-file": "Enviar archivo",
  "general-move": "Mover",
  "general-rename": "Rebautizar",
  "general-upload-files": "Subir archivos",
  "general-new-folder": "Nueva carpeta",
  "general-not-informed": "No informado",
  "general-insertion-date": "Fecha de inserción",
  "general-name": "Nombre",
  "general-documents": "Documentos",
  "general-general-prasentation": "Presentación general",
  "general-folder": "Carpeta",
  "general-folders": "Carpetas",
  "general-output": "Salida",
  "general-report-type": "tipo de informe",
  "general-client": "Cliente",
  "general-insert": "Insertar",
  "general-save": "Guardar",
  "general-cancel": "Cancelar",
  "general-send": "Enviar",
  "general-delete": "Eliminar",
  "general-update": "Actualizar",
  "general-updated": "Actualizado",
  "general-loading": "Cargando",
  "general-network-error": "Error de red",
  "general-network-error-message": "Por favor, verifica tu conexión o si el servidor está en funcionamiento.",
  "general-request-error": "Error al procesar la solicitud",
  "general-search": "Buscar",
  "general-dashboard": "Panel",
  "general-administration": "Administración",
  "general-settings": "Ajustes",
  "general-logs": "Registros",
  "general-monitoring": "Supervisión",
  "general-users": "Usuarios",
  "general-duplicate": "Duplicar",
  "general-register": "Registro",
  "general-groups": "Grupos",
  "general-portuguese-br": "Portugués-BR",
  "general-spanish-es": "Español-ES",
  "general-english-us": "Inglés-US",
  "general-active": "Activo",
  "general-yes": "Sí",
  "general-no": "No",
  "general-type-observation": "Escribe observacion",
  "general-observation": "Observación",
  "general-observations": "Observaciónes",
  "general-corporate-reason": "Razón Social",
  "general-cnpj": "CNPJ",
  "general-fantasy-n": "N.Comercial",
  "general-fantasy-name": "Nombre Comercial",
  "general-optional": "Opcional",
  "general-institution": "Institución",
  "general-surname": "Apellido",
  "general-user-or-email": "Usuario o correo electrónico",
  "general-filter": "Filtrar",
  "general-filters": "Filtros",
  "general-clear": "Limpiar",
  "general-apply": "Aplicar",
  "general-next": "Próximo",
  "general-confirm": "Confirmar",
  "general-form-invalid": "Forma invalida",
  "general-user": "Usuario",
  "general-month": "Mes",
  "general-year": "Año",
  "general-day": "Día",
  "general-actual": "Actual",
  "general-shopping": "Compras",
  "general-sofr": "SOFR",
  "general-derivatives-index": "Índice de derivados",
  "general-cost-savings-comparison": "Comparación de ahorro de costos",
  "general-bankability-score": "Puntaje de bancabilidad",
  "general-good-credit-score": "Buen puntaje crediticio",
  "general-economic-calendar": "Calendario económico",
  "general-available-credit-contracted": "Crédito Disponible x Contratado",
  "general-cdi": "CDI",
  "general-ipca": "IPCA",
  "general-time": "Tiempo",
  "general-event": "Evento",
  "general-real": "Real",
  "general-previous": "Previa",
  "general-forecast": "Pronóstico",
  "general-address": "Dirección",
  "general-site": "Sitio web",
  "general-your-browser-does-not-support-video": "Su navegador no soporta la etiqueta de video",
  "general-required-field": "Campo obligatorio",
  "general-ok": "Ok",
  "general-file": "Archivo",
  "general-files": "Archivos",
  "general-size": "Tamaño",
  "general-to-go-back": "Volver",
  "general-category": "Categoría",
  "general-review": "Revisar",
  "general-document": "Documento",
  "general-reject": "Rechazar",
  "general-approve": "Aprobar",
  "general-download": "Descargar",
  "general-all": "Todo",
  "general-no-user-registered-for-selected-company": "No hay usuario registrado para la empresa seleccion",
  "general-write-adescription": "Escribe una descripción",
  "general-write-aname": "Escribe un nombre",
  "general-description": "Descripción",
  "general-finalize": "Finalizar",
  "general-everything-is-fine": "¡Todo está bien!",
  "general-oops-something-went-wrong": "¡Vaya, algo salió mal!",
  "general-actions": "Acciones",
  "general-go-back": "Volver",
  "general-shrink-expand": "Encoger/Expandir",
  "general-expand1": "Expandir",
  "general-shrink": "encoger",
  "general-select1": "Seleccionar",
  "general-uncheck": "desmarcar",
  "general-export1": "Exportar",
  "general-operations-exported-successfully": "¡Operaciones exportadas con éxito!",
  "general-edit": "Editar",
  "general-add-contact": "Agregar Contacto",
  "general-contact-name": "Nombre del Contacto",
  "general-telephone": "Teléfono",
  "general-job-title": "Cargo",
  "general-email": "Correo electrónico",
  "general-description1": "Descripción",
  "general-contacts": "Contactos",
  "general-data-loss-warning": "Todos los datos ingresados se perderán.",
  "general-global-limit": "Límite Global",
  "general-add": "Agregar",
  "general-information-edited-successfully": "¡Información editada con éxito!",
  "general-company": "Empresa",
  "general-limit-type": "Tipo de límite",
  "general-value": "Valor",
  "general-share": "Compartir",
  "general-list": "listar",
  "general-to-see": "Ver",
  "general-create": "Crear",
  "general-period": "Período",
  "general-select-month": "Seleccione el mes",
  "general-select-year": "Seleccione el año",
  "general-expiration-period": "Período de Vencimiento",
  "general-initial-data": "Datos Iniciales",
  "general-select-start-date": "Seleccione la fecha de inicio",
  "general-final-date": "Fecha Final",
  "general-select-end-date": "Seleccione la fecha de finalización",
  "general-operation-type1": "Tipo de Operación",
  "general-select-operation-type": "Seleccione el tipo de operación",
  "general-output-format": "Formato de Salida",
  "general-generate-report": "Generar Informe",
  "general-select-customer": "Seleccione el cliente",
  "general-cog-ai": "Cog IA",
  "general-remove": "Eliminar",
  "general-reference": "Referencia",
  "general-asset-type": "Tipo de Activo",
  "general-asset-description": "Descripción del Activo",
  "general-assessed-value": "Valor Evaluado",
  "general-evaluation-date": "Fecha de Evaluación",
  "general-value-of-guarantee": "Valor de Garantía",
  "general-warranty-status": "Estado de la Garantía",
  "general-percentage-compromised": "% Comprometida",
  "general-control-module": "Control",
  "general-performance-module": "Rendimiento",
  "general-negotiation-moduke": "Negociación",
  "general-remove-uploaded-file": "Eliminar archivo enviado",
  "general-confirm-file-removal": "¿Está seguro de que desea eliminar el archivo enviado?",
  "general-file-removed-successfully": "¡Archivo eliminado con éxito!",
  "general-social-contract-and-contractual-amendments-of-the-holding": "Contrato social y modificaciones contractuales de la holding",
  "general-holding-financial-statements-last3-years": "Estados financieros de la Holding (últimos 3 años)",
  "general-de": "de",
  "general-files1": "archivo(s)",
  "general-file-limit-reached": "Límite de archivos alcanzado",
  "general-max-files-limit": "Puedes agregar un máximo de {maxFiles} archivos.",
  "general-registration-date": "Fecha de Registro",
  "general-zip-code": "Código Postal",
  "general-city": "Ciudad",
  "general-uf": "UF",
  "general-qualification": "Calificación",
  "general-country": "país",
  "general-legal-representative": "Representante Legal",
  "general-qsa-receita-federal": "QSA - Agencia Federal de Ingresos",
  "general-legal-representative-qualification": "Calificación del Representante Legal",
  "general-no-records-found": "No se encontraron registros",
  "general-sector1": "Sector",
  "general-site1": "Sitio",
  "general-remove-operation": "Eliminar operación",
  "general-invalid-cnpj": "CNPJ inválido",
  "general-email-sent-successfully": "¡Correo electrónico enviado con éxito!",
  "general-registration-data": "Datos de Registro",
  "general-derivative": "Derivativo",
  "general-view-all": "Ver todos",
  "general-view-operation": "Ver Operación",
  "general-events-in": "Eventos en",
  "general-import-operations": "Importar operaciones",
  "general-extracting-operations": "Extrayendo operaciones...",
  "general-send-file-or-text-to-extract-operations": "Envía un archivo o un texto para extraer las operaciones",
  "general-create-with-cog-ai": "Crear con COG AI",
  "general-drag-image-here-or-paste-from-clipboard": "Arrastra una imagen aquí o pega desde el portapapeles",
  "general-start-from-image": "Comenzar desde la Imagen",
  "general-select-image": "Seleccionar Imagen",
  "general-preview": "Previsualización",
  "general-from-text": "A partir de texto",
  "general-operations-imported-successfully": "las operaciones se importaron con éxito",
  "general-operations-not-imported-due-to-different-currencies": "las operaciones no fueron importadas porque son de diferentes monedas",
  "general-current-demand-currency": "de la moneda actual de la demanda",
  "general-selected-columns": "columnas seleccionadas",
  "general-select-columns": "Seleccione las columnas",
  "general-columns1": "Columnas",
  "general-parity": "paridad",
  "general-operation-id": "Id de Operación",
  "general-cap1": "tapa",
  "general-volume": "Volumen",
  "general-future-value": "Valor Futuro",
  "general-select-bank-before-continue": "Seleccione un banco antes de continuar.",
  "general-in-thousands": "En Miles",
  "general-create-operations-with-cog-ai": "Crear operaciones con Cog AI",
  "general-annual-hedge-cost-percentage": "Costo anual de cobertura %",
  "general-preparing-download": "Preparando Descarga",
  "general-downloading-file": "Descargando archivo",
  "general-error-downloading": "Error al descargar",
  "general-compressing-files": "Compactando archivos",
  "general-download-error": "Error en el proceso de descarga",
  "general-error-generating-pdf": "Ocurrió un error al generar el PDF",
  "general-generating-pdf1": "Generando PDF...",
  "general-reports": "Informes",
  "general-generating-excel": "Generando Excel...",
  "general-select-all": "Seleccionar todos",
  "general-manage": "Gestionar",
  "general-click-here-to-register": "Haga clic aquí para registrarse",
  "general-current-time": "Hora Actual",
  "general-expiration-calendars": "Calendarios de Vencimiento",
  "general-register1": "Register",
  "general-demand1": "Demand",
  "general-purpose": "Finalidad",
  "general-status1": "Estado",
  "general-currency1": "Moneda",
  "general-flow2": "Flujo",
  "general-supplier1": "Proveedor",
  "general-attach-contract": "Adjuntar Contrato",
  "general-agency-and-account": "Agencia y Cuenta",
  "general-additional-costs1": "Costos Adicionales",
  "general-total-convertido": "Total Convertido",
  "general-bank-payer": "Banco Pagador",
  "general-country1": "País",
  "general-displaying": "Mostrando",
  "general-no-items-found": "No se encontraron elementos",
  "general-data-contracting": "Fecha de Contratación",
  "general-value2": "Valor",
  "general-in-development": "En desarrollo",
  "general-feature-not-available": "Esta funcionalidad aún no está disponible.",
  "general-select-company-to-start": "Para comenzar, seleccione una empresa",
  "general-start-modeling-select-company": "Para iniciar la modelización, seleccione una empresa arriba.",
  "general-launch-instalments": "Lanzar Cuotas",
  "general-attention1": "¡Atención!",
  "general-details1": "Detalles",
  "general-demand-link-comex-loan": "Esta demanda necesita estar vinculada a un Comex o préstamo",
  "general-responsible-user": "Usuario Responsable",
  "general-priority": "Prioridad",
  "general-expected-final-date": "Fecha final prevista",
  "general-priority1": "Prioridad",
  "general-add-comment": "Agregar Comentario",
  "general-delete-comment": "Eliminar comentario",
  "general-expected-end-date": "Fecha de finalización prevista",
  "general-add-task": "Agregar tarea",
  "general-document-deleted-successfully": "Documento eliminado con éxito",
  "general-error-deleting-document": "Error al eliminar documento",
  "general-operation-date-start": "Fecha de la operación (inicio)",
  "general-operation-date-end": "Fecha de la operación (fin)",
  "general-all-a": "Todas",
  "general-all-companies": "Todas las empresas",
  "management-insertion-date": "Fecha de inserción",
  "management-reports": "Reactores",
  "management-home": "Home",
  "management-onboarding": "Onboarding",
  "management-back-office": "Back office",
  "management-document-analysis": "Análisis de documentos",
  "management-data-room": "Sala de datos",
  "management-types-of-credit-limit": "Tipos de límite de crédito",
  "management-billing": "Facturación",
  "management-loans": "Préstamos",
  "management-no-loans-registered": "Ninguna operación de préstamo registrada",
  "management-cost": "Costo",
  "management-demands": "Demandas",
  "management-hedge-accounting": "Contabilidad de cobertura",
  "management-mark-to-market": "Valor razonable (Vr)",
  "management-risk-management": "Gestión de riesgos",
  "management-indebtedness": "Endeudamiento",
  "management-collateral-registry": "Registro de garantías",
  "management-credit-demand": "Demanda de crédito",
  "management-debt-registry": "Registro de deudas",
  "management-debt-report": "Informe de deudas",
  "management-debt-flow": "Flujo de deudas",
  "management-import-control": "Control de importación",
  "management-credit": "Crédito",
  "management-economic-analysis": "Análisis económico",
  "management-financial-statements": "Estados financieros",
  "management-cash-flow-statement": "Estado de flujo de efectivo",
  "management-income-statement": "Estado de resultados",
  "management-balance-sheet": "Balance general",
  "management-dashboard": "Tablero de mando",
  "management-assumptions": "Supuestos",
  "management-projects": "Proyectos",
  "management-scope": "Alcance",
  "management-physical-financial-schedule": "Cronograma físico/financiero",
  "management-cash-flow": "Flujo de efectivo",
  "management-financial-modeling": "Modelado financiero",
  "management-business-case": "Caso de negocio",
  "management-project-finance": "Financiación de proyectos",
  "management-market": "Mercado",
  "management-credit-operations-pipeline": "Pipeline de operaciones de crédito",
  "management-bank-accounts": "Cuentas bancarias",
  "management-financial-institution": "Institución financiera",
  "management-financial-institutions": "Instituciones financieras",
  "management-management": "Gestión",
  "management-id": "Id",
  "management-name": "Nombre",
  "management-compensation-code": "Cód. de Compensación",
  "management-description": "Descripción",
  "management-associates": "Associados",
  "management-users": "Usuarios",
  "management-user": "Usuario",
  "management-status": "Estado",
  "management-actions": "Comportamiento",
  "management-clients": "Cliente",
  "management-data": "Fecha",
  "management-days": "Días",
  "management-financial-institution-created-successfully": "Institución financiera creada con éxito",
  "management-financial-institution-updated-successfully": "Institución financiera editada con éxito",
  "management-financial-institution-deleted-successfully": "Institución financiera eliminada con éxito",
  "management-no-financial-institutions-registered": "No se han registrado instituciones financieras",
  "management-attachment-type": "Tipo de archivo adjunto",
  "management-attachment-types": "Tipos de archivos adjuntos",
  "management-no-attachment-types-registered": "No se han registrado tipos de archivos adjuntos",
  "management-add-attachment-type": "Agregar tipo de archivo adjunto",
  "management-attachment-type-created-successfully": "Tipo de archivo creado con éxito",
  "management-attachment-type-updated-successfully": "Tipo de archivo actualizado con éxito",
  "management-attachment-type-deleted-successfully": "Tipo de archivo eliminado con éxito",
  "management-tenant": "Tenant",
  "management-tenants": "Tenants",
  "management-no-tenants-registered": "No hay tenants registrados",
  "management-add-tenant": "Agregar",
  "management-tenant-created-successfully": "Tenant creado con éxito",
  "management-tenant-updated-successfully": "Tenant actualizado con éxito",
  "management-tenant-deleted-successfully": "Tenant eliminado con éxito",
  "management-financial-institution-title-delete-confirmation": "¿Está seguro de que desea eliminar esta institución financiera?",
  "management-financial-institution-description-delete-confirmation": "La institución financiera perderá todo acceso al sistema.",
  "management-attachment-type-title-delete-confirmation": "¿Está seguro de que desea eliminar este tipo de archivo adjunto?",
  "management-attachment-type-description-delete-confirmation": "El tipo de archivo adjunto se eliminará del sistema.",
  "management-tenant-title-delete-confirmation": "¿Está seguro de que desea eliminar este tenant?",
  "management-tenant-description-delete-confirmation": "El tenant será eliminado del sistema.",
  "management-company": "Empresa",
  "management-companys": "Empresas",
  "management-no-companys-registered": "No hay empresas registrados",
  "management-add-company": "Adicionar cliente",
  "management-company-created-successfully": "Empresa creado con éxito",
  "management-company-updated-successfully": "Empresa actualizado con éxito",
  "management-company-deleted-successfully": "Empresa eliminado con éxito",
  "management-company-delete-confirmation-title": "¿Está seguro de que desea eliminar este empresas?",
  "management-company-delete-confirmation-description": "Lo cliente perderá todo acceso al sistema.",
  "management-company-all-companys": "Todos los empresas",
  "management-ndf-calculator": "Calculadora de NDF",
  "management-ndf-new-demand": "Nueva  demanda",
  "management-ndf-export-to-excel": "Exportar a Excel",
  "management-ndf-simulations": "Simulaciones",
  "management-ndf-listed": "Listado",
  "management-ndf-contractors": "Contratistas",
  "management-ndf-currency": "Moeda",
  "management-ndf-demands": "Demandas",
  "management-ndf-creation": "Creación",
  "management-derivatives": "Derivados",
  "management-ndf-scenario": "Escenario",
  "management-ndf-scenarios": "Escenarios",
  "management-ndf-new-scenario": "Nuevo escenario",
  "management-ndf-operation": "Operación",
  "management-ndf-operation-type": "Operation type",
  "management-ndf-hired-operation": "Operaciones contratadas",
  "management-ndf-value": "Valor",
  "management-ndf-due-date": "Vencimiento",
  "management-ndf-due-date-initial": "Vencimiento Inicial",
  "management-ndf-due-date-final": "Vencimiento Final",
  "management-ndf-reference": "Referencia",
  "management-ndf-remarks": "Observaciónes",
  "management-ndf-import": "Importar",
  "management-ndf-export": "Exportar",
  "management-ndf-loan": "Préstamo",
  "management-ndf-pin-unpin": "Fijar/Desfijar",
  "management-ndf-add-trading-note": "Agregar nota comercial",
  "management-ndf-demand-management": "Gestión de la demanda",
  "management-ndf-operation-management": "Gestión de operaciones",
  "management-ndf-quote": "Cita",
  "management-ndf-quotation": "Cotización",
  "management-ndf-successfully-contracted": "Contratada exitosamente",
  "management-ndf-date-operations": "Fecha de operación",
  "management-no-demand-registered": "Nenhuma demanda registrada",
  "management-ndf-deadline-days": "Plazo (Días)",
  "management-ndf-calendar-days": "Dias corridos",
  "management-ndf-working-days": "Días hábiles",
  "management-ndf-exchange": "Intercambio",
  "management-ndf-rate": "Tasa",
  "management-ndf-to-hire": "Contratar",
  "management-ndf-demand": "Demanda",
  "management-ndf-add-simulation": "Agregar simulación",
  "management-ndf-you-have": "Tienes",
  "management-ndf-bank": "Banco",
  "management-ndf-date-of-operation": "Fecha de operación",
  "management-ndf-notional": "Notional",
  "management-ndf-forward": "Forward",
  "management-ndf-forward-brl-me": "Forward (BRL/ME)",
  "management-ndf-volume-protected-up-to-cap": "Volumen protegido hasta CAP",
  "management-ndf-last-date-ptax-passed-cap": "Última fecha en que PTAX aprobó CAP",
  "management-ndf-reference-exchange": "Intercambio de referencia",
  "management-ndf-notional-brl-by-reference": "BRL nocional por referencia",
  "management-ndf-nominal-cost-brl": "Costo nominal (BRL)",
  "management-ndf-nominal-cost": "Costo nominal",
  "management-ndf-settlement-fee": "Tarifa de liquidación",
  "management-ndf-settlement-spot": "Spot",
  "management-ndf-add-scenario": "Agregar escenario",
  "management-ndf-simulation": "Simulación",
  "management-ndf-select-the-bank": "Seleccione el banco",
  "management-ndf-insert-date": "Insertar la fecha",
  "management-ndf-enter-due-date": "Ingrese la fecha de vencimiento",
  "management-ndf-insert-days": "insertar días",
  "management-ndf-insert-notional": "Insertar notional",
  "management-ndf-insert-forward": "Insertar forward",
  "management-ndf-insert-cap": "Insertar CAP",
  "management-ndf-to-compare": "comparar",
  "management-ndf-cap": "CAP",
  "management-ndf-notional-flat": "Notional (flat)",
  "management-ndf-notional-aa": "Notional (a.a)",
  "management-ndf-create-demand": "Crear demanda",
  "management-ndf-create-simulation": "Crear simulación",
  "management-ndf-simulate": "Simular",
  "management-ndf-demand-is-invalid": "Demanda inválida",
  "management-ndf-simulation-is-invalid": "Simulación inválida",
  "management-ndf-derivative-information": "Información derivada",
  "management-ndf-deadline": "Fecha límite",
  "management-ndf-notion-me": "Notion (ME)",
  "management-ndf-new-operation": "Nuevas operaciones",
  "management-ndf-no-operation-registred": "Nenhuma operación registrada",
  "management-ndf-derivatives-operations-management": "Gestión de operaciones de derivados",
  "management-ndf-derivatives-management": "Gestión de derivados",
  "management-ndf-quote-saved-successfully": "Cotización guardada exitosamente!",
  "management-ndf-hire-saved-successfully": "Contratar guardado exitosamente!",
  "management-ndf-reference-fees": "Tarifas de referencia",
  "management-ndf-insert-fee": "Insertar tarifa",
  "management-ndf-settle-operation": "Operación de liquidación",
  "management-ndf-finalize-settlement": "Finalizar el acuerdo",
  "management-ndf-duplicate-simulation": "Simulación duplicada",
  "management-ndf-demand-simulation-created-successfully": "Simulación de demanda creada con éxito",
  "management-ndf-operations": "Operaciones",
  "management-ndf-demand-saved-successfully": "¡La demanda se guardó con éxito!",
  "management-ndf-date-and-time": "Fecha y hora",
  "management-ndf-hire-quote": "Cotización de alquiler",
  "management-ndf-settle-contract": "Resolver contrato",
  "management-operation-title-delete-confirmation": "¿Estás seguro de que deseas eliminar esta operación?",
  "management-ndf-settlement-information": "Información de liquidación",
  "management-ndf-add-settlement-note": "Agregar nota de liquidación",
  "management-ndf-add-settlement-reversed": "Guardar reversión",
  "management-ndf-add-settlement-reversed-title": "Haga clic para guardar la reversión de la operación. Esta reversión genera una copia de la operación actual sin afectarla.",
  "management-ndf-early-reversal-liquidation-success": "Reversión liquidada anticipadamente con éxito",
  "management-ndf-early-reversal-liquidation-error": "Error al liquidar anticipadamente la reversión",
  "management-ndf-form-invalid": "Formulario inválido",
  "management-ndf-please-check-fields": "Por favor, verifique todos los campos obligatorios",
  "management-ndf-no-response-received": "No se recibió respuesta del servidor",
  "management-ndf-settlement-date": "Fecha de liquidación",
  "management-ndf-notional-settlement": "Liquidación nocional",
  "management-ndf-irrf": "IRRF",
  "management-ndf-irto-pay": "IR por pagar",
  "management-ndf-net-adjustment": "Ajuste neto",
  "management-ndf-gross-adjustment": "Ajuste Bruto",
  "management-ndf-operation-successfully-selled": "Operación vendida con éxito",
  "management-ndf-simulated": "Simulado",
  "management-ndf-quoted": "Cotado",
  "management-ndf-hired": "Contratado",
  "management-ndf-demand-title-delete-confirmation": "¿Estás seguro de que deseas eliminar esta demanda?",
  "management-ndf-demand-deleted-successfully": "Demanda eliminada con éxito",
  "management-ndf-full-on-maturity": "Completo al vencimiento",
  "management-ndf-before-maturity": "Completo antes del vencimiento",
  "management-ndf-partial": "Parcial",
  "management-ndf-settlement-notional": "Notional de liquidación",
  "management-error-loading-tenants": "Error al cargar tenants",
  "management-error-loading-tenant": "Error al cargar tenant",
  "management-error-removing-tenant": "Error al eliminar tenant",
  "management-error-creating-tenant": "Error al crear tenant",
  "management-error-updating-tenant": "Error al actualizar tenant",
  "management-error-loading-financial-institutions": "Error al cargar instituciones financieras",
  "management-error-loading-financial-institution": "Error al cargar institución financiera",
  "management-error-removing-financial-institution": "Error al eliminar institución financiera",
  "management-error-creating-financial-institution": "Error al crear institución financiera",
  "management-error-updating-financial-institution": "Error al actualizar institución financiera",
  "management-error-loading-companys": "Error al cargar empresas",
  "management-error-loading-company": "Error al cargar empresa",
  "management-error-removing-company": "Error al eliminar empresa",
  "management-error-creating-company": "Error al crear empresa",
  "management-error-updating-company": "Error al actualizar empresa",
  "management-error-loading-attachment-types": "Erro al cargar tipos de archivos adjuntos",
  "management-error-loading-attachment-type": "Erro al cargar tipo de archivo adjunto",
  "management-error-removing-attachment-type": "Erro al eliminar tipo de archivo adjunto",
  "management-attachment-type-removed-successfully": "Tipo de archivo adjunto eliminado con éxito",
  "management-error-creating-attachment-type": "Erro al crear tipo de archivo adjunto",
  "management-error-updating-attachment-type": "Erro al actualizar tipo de archivo adjunto",
  "management-error-loading-operations": "Erro al cargar operaciones",
  "management-error-loading-operation": "Erro al cargar operación",
  "management-error-removing-operation": "Erro al eliminar operación",
  "management-operation-removed-successfully": "Operación eliminada con éxito",
  "management-error-creating-operation": "Erro al crear operación",
  "management-operation-created-successfully": "Operación creada con éxito",
  "management-error-updating-operation": "Erro al actualizar operación",
  "management-operation-updated-successfully": "Operación actualizada con éxito",
  "management-error-loading-operations-status-count": "Erro al cargar el recuento de estado de operaciones",
  "management-error-loading-previous-day-ptax": "Erro al cargar PTAX del día anterior",
  "management-error-loading-internacional-currencies": "Erro al cargar monedas internacionales",
  "management-error-loading-operation-max-value": "Erro al cargar el valor máximo de la operación",
  "management-error-loading-demands": "Error al cargar demandas",
  "management-error-loading-demand": "Error al cargar demanda",
  "management-error-removing-demand": "Error al eliminar demanda",
  "management-error-creating-demand": "Error al crear demanda",
  "management-demand-created-successfully": "Demanda creada con éxito",
  "management-demand-simulation-created-successfully": "Simulación de demanda creada con éxito",
  "management-error-updating-demand": "Error al actualizar demanda",
  "management-error-loading-demand-max-value": "Error al cargar el valor máximo de la demanda",
  "management-error-creating-demand-simulation": "Error al crear simulación de demanda",
  "management-error-calculating-due-date": "Error al calcular la fecha de vencimiento",
  "management-error-loading-highest-twelve-month-above-cap": "Error al cargar los doce meses más altos por encima de CAP",
  "management-ndf-operation-status": "Status da operação",
  "management-ndf-financial-status": "status financeiro",
  "management-ndf-composition": "Composição",
  "management-ndf-open": "Aberto",
  "management-ndf-settled": "Liquidado",
  "management-ndf-settled-reversed": "Reversión",
  "management-ndf-full": "Integral",
  "management-ndf-quotation-date-hour-confirmation": "¿Está seguro de que desea realizar la cotización en la fecha/hora?",
  "management-ndf-hire-date-hour-confirmation": "¿Está seguro de que desea contratar en la fecha/hora?",
  "management-ndf-time": "Hora",
  "management-ndf-origem": "Origen",
  "management-ndf-financial-operator": "Operador financeiro (banco)",
  "management-ndf-revert-to-quoted": "Revertir a citado",
  "management-ndf-revert-liquidated-to-open": "Revertir liquidado a abierto",
  "management-ndf-operation-reverted-successfully": "Operación revertida con éxito",
  "management-ndf-error-reverting-operation": "Erro al revertir la operación",
  "management-ndf-operation-title-revert-liquidation-confirmation": "¿Está seguro de que desea revertir la liquidación de esta operación?",
  "management-ndf-settlement-scenarios": "Escenarios de liquidación",
  "management-ndf-settlement-exchange": "Intercambio de liquidación",
  "management-ndf-cost-per-year-per-scenario": "Costo por año por escenario",
  "management-ndf-cost-per-year-scenario-reference-exchange-rate": "Costo por año por Escenarios al Tipo de Cambio de Referencia",
  "management-ndf-annual-cost": "Costo anual",
  "management-ndf-settlement-rate": "Tarifa de liquidación",
  "management-ndf-withholding-tax": "IRRF",
  "management-ndf-income-tax-payable": "IR a pagar",
  "management-see-operations": "Operations",
  "management-add-credit-limit-type": "Agregar Tipo de Límite de Crédito",
  "management-no-credit-limit-type-founded": "Ningún tipo de límite de crédito registrado",
  "management-document-analysis-queue": "Cola de análisis de documentos",
  "management-error-loading-files": "Error al cargar archivos",
  "management-company-name": "Nombre de la empresa",
  "management-documents-for-analysis": "Documentos para análisis",
  "management-upload-date": "Fecha de carga",
  "management-finalize-analysis": "Finalizar análisis",
  "management-save-without-approving-or-rejecting": "Guardar sin aprobar o rechazar",
  "management-under-review": "En revisión",
  "management-are-you-sure-you-want-to-reject": "¿Estás seguro de que quieres rechazar?",
  "management-this-action-cannot-be-undone": "Esta acción no se puede deshacer",
  "management-are-you-sure-you-want-to-finish": "¿Estás seguro de que quieres terminar?",
  "management-the-review-will-be-saved-nsent-to-customer": "La reseña se guardará y se enviará al cliente",
  "management-there-are-unrated-files": "¡Hay archivos sin clasificar!",
  "management-check-before-approving": "Verifique antes de aprobar",
  "management-preview-unavailable-download-file": "Vista previa no disponible. ¡Descarga el archivo!",
  "management-document-rejected": "Documento rechazado",
  "management-document-rejected-successfully": "Documento rechazado con éxito",
  "management-error-rejecting-document": "Error al rechazar el documento",
  "management-document-approved": "Documento aprobado",
  "management-document-approved-successfully": "Documento aprobado con éxito",
  "management-error-approving-document": "Error al aprobar el documento",
  "management-limit-type-registered-successfully": "¡Tipo de límite registrado con éxito!",
  "management-credit-limit-deleted-successfully": "¡límite de crédito eliminado con éxito!",
  "management-delete-credit-limit": "¿Eliminar límite de crédito?",
  "management-confirm-delete-credit-limit": "¿Está seguro de que desea eliminar este límite de crédito?",
  "management-indicative": "indicativo",
  "management-contracted-operations": "Con operaciones contratadas",
  "management-contracts-active-and-open": "Con operaciones contratadas y abiertas",
  "management-budget-rate1": "Tipo de Cambio de Contratación",
  "management-exchange-exhibition": "Exposición Cambial",
  "management-hedge-position1": "Posición de Cobertura",
  "management-settled-operations": "Operaciones Liquidadas",
  "management-revert-to-simulated": "Revertir a Simulado",
  "management-status-reversion": "Reversión de estado",
  "management-confirm-reversal-quotation-to-simulated": "¿Estás seguro de que deseas revertir la cotización y establecer el estado de esta operación como Simulado?",
  "management-confirm-reverse-settlement-set-status-open": "¿Está seguro de que desea revertir la liquidación y establecer el estado de esta operación como 'Contrato Abierto'?",
  "management-confirm-revert-contract-status-quoted": "¿Está seguro de que desea revertir la contratación y establecer el estado de esta operación en Cotizado?",
  "management-operation-start-date": "Fecha de inicio de operación",
  "management-operation-end-date": "Fecha de finalización de la operación",
  "management-search-data-receita-federal": "Buscar datos en la Receita Federal",
  "management-unsaved-operations-warning": "Has seleccionado operaciones no guardadas, necesitas guardar la solicitud primero.",
  "management-incomplete-fields-warning": "Atención: hay campos sin completar o operaciones incompletas. Finalice todos los elementos antes de guardar.",
  "management-remove-operation-save-demand": "Para eliminar una operación, guarda primero la solicitud.",
  "management-demand-type": "Tipo",
  "management-confirm-remove-operation": "¿Está seguro de que desea eliminar esta operación de la demanda?",
  "management-operations-removal-security": "Por seguridad, solo se pueden eliminar las operaciones con el estado 'Simulado'.",
  "management-reject-document": "Rechazar Documento",
  "management-approve-document": "Aprobar Documento",
  "management-approve-document-confirmation": "¿Está seguro de que desea aprobar este documento?",
  "management-approve-all-documents": "Aprobar todos",
  "management-approve-all-documents-confirmation": "Todos los documentos pendientes de esta empresa serán aprobados. Los documentos ya aprobados o rechazados no se modificarán y no se enviará ningún correo al cliente.",
  "management-approve-all-documents-success": "{{applied}} documento(s) aprobado(s)",
  "management-approve-all-documents-partial": "{{applied}} aprobado(s), {{failed}} con error",
  "management-approve-all-documents-none-applied": "No se aprobó ningún documento",
  "management-approve-all-documents-skipped": "{{skipped}} documento(s) sin cambios",
  "management-error-sending-email-analysis-results": "Error al enviar el correo electrónico con los resultados del análisis de los documentos",
  "management-document-analysis1": "Análisis de Documentos",
  "management-password-recovery-link": "Enlace de Recuperación de Contraseña",
  "management-send-email-password-recovery": "Enviar Correo Electrónico de Recuperación de Contraseña",
  "management-modality": "Modalidad",
  "management-monthly": "Mensual",
  "management-quarterly": "trimestral",
  "management-cost-consideration-low-strike": "Se consideró el costo al alcanzar el low strike. El costo puede variar según la fluctuación del tipo de cambio.",
  "management-error-loading-di": "Error al cargar Di",
  "management-factor-di": "Factor DI",
  "management-derivative-management": "Gestión de Derivativos",
  "management-derivative-demand-not-found": "No fue posible encontrar la demanda de derivado asociada.",
  "management-derivative-operation-not-found": "No se pudo encontrar la operación de derivado asociada.",
  "management-link-operation-to-loan-or-comex": "Es necesario vincular esta operación a un Préstamo o Comex. Realice la asociación antes de guardar los cambios.",
  "management-linked-installments": "instalaciones vinculadas",
  "management-linked-installment": "cuota vinculada",
  "management-expiration1": "Vencimiento",
  "management-link-installments": "Vincular cuotas",
  "management-ispb": "ISPB",
  "management-short-name": "Nombre corto",
  "management-display-name": "Nombre de exhibición",
  "management-network": "Red",
  "management-url": "URL",
  "management-revert-hiring": "Revertir contratación",
  "management-market-projection-curves": "Curvas de Proyección de Mercado",
  "market-customer-documents": "Documentos del cliente",
  "market-customer-folders": "Carpeta de cliente",
  "market-contract-folders": "Carpetas de contratos",
  "market-no-folders-found": "No se encontraron carpetas",
  "market-no-company-found": "No se encontró ninguna empresa",
  "market-no-folders-documents-found": "No se encontraron carpetas ni documentos",
  "market-where-do-you-want-to-move": "¿Adónde quieres mudarte?",
  "market-folder-created-successfully": "¡Carpeta creada con éxito!",
  "market-error-creating-folder": "¡Error al crear la carpeta!",
  "market-unable-to-create-new-folder": "No se pudo crear una nueva carpeta.",
  "market-file-renamed-successfully": "Archivo renombrado con éxito!",
  "market-error-renaming-file": "¡Error al renombrar el archivo!",
  "market-unable-to-rename-file": "No se pudo renombrar el archivo",
  "market-file-moved-successfully": "¡Archivo movido con éxito!",
  "market-error-moving-file": "¡Error al mover el archivo!",
  "market-unable-to-move-file": "No se pudo mover el archivo",
  "market-upload-file-successfully": "Subir archivo correctamente",
  "market-error-on-upload-file": "Error al subir archivo",
  "market-unable-to-upload-file": "No se puede subir el archivo",
  "market-folder-moved-successfully": "¡Carpeta movida con éxito!",
  "market-folder-renamed-successfully": "¡Carpeta renombrada con éxito!",
  "market-sending-file": "Enviando archivo...",
  "market-create-bank-relationship": "",
  "market-register-bank-relationship": "Registrar Relación Bancaria",
  "market-account-info-and-contacts-linked": "Información de la cuenta y contactos vinculados",
  "market-account-number": "Número de Cuenta",
  "market-agency": "Agencia",
  "market-bank": "Banco",
  "market-add-bank-account": "Agregar Cuenta Bancaria",
  "market-no-account-registered": "Ninguna cuenta registrada",
  "market-credit-limit": "Límite de crédito",
  "market-add-distribution": "Agregar Distribución",
  "market-global-credit": "Crédito Global",
  "market-limit-distribution": "Distribución de límite",
  "market-no-credit-limit-registered": "Ningún límite de crédito registrado",
  "market-account": "Cuenta",
  "market-accounts-count": "Número de cuentas",
  "market-account-type": "Tipo de cuenta",
  "market-limit-type-registered-successfully": "¡Tipo de límite registrado con éxito!",
  "market-checking": "Cuenta corriente",
  "market-savings": "Cuenta de ahorros",
  "market-investment": "Cuenta de inversión",
  "market-retirement": "Cuenta de jubilación",
  "market-credit": "Cuenta de crédito",
  "market-loan": "Cuenta de préstamo",
  "market-joint": "Cuenta conjunta",
  "market-business": "Cuenta empresarial",
  "market-student": "Cuenta estudiantil",
  "market-trust": "Cuenta fiduciaria",
  "market-payroll": "Cuenta nómina",
  "market-cash-management": "Cuenta de gestión de efectivo",
  "market-foreign-currency": "Cuenta en moneda extranjera",
  "market-crypto-currency": "Cuenta de criptomonedas",
  "market-custodial": "Cuenta de custodia",
  "market-broker": "Cuenta de corretaje",
  "market-charity": "Cuenta de caridad",
  "market-escrow": "Cuenta de depósito en garantía",
  "market-offshore": "Cuenta offshore",
  "market-margin": "Cuenta de margen",
  "market-government": "Cuenta gubernamental",
  "market-virtual": "Cuenta virtual",
  "market-other": "Otro",
  "market-bank-relationship1": "",
  "market-bank-relationship2": "",
  "market-bank-relationship3": "",
  "market-bank-relationship": "Relacionamento bancario",
  "market-no-bank-account-registered": "¡No hay cuenta bancaria registrada!",
  "market-delete-bank-relationship": "¿Eliminar relación bancaria?",
  "market-confirm-delete-bank-relationship": "¿Está seguro de que desea eliminar esta relación bancaria?",
  "market-bank-relationship-deleted-successfully": "¡Relación bancaria eliminada con éxito!",
  "market-delete-limit-distribution": "¿Eliminar distribución de límite?",
  "market-delete-limit-distribution-confirmation": "¿Está seguro de que desea eliminar esta distribución de límite?",
  "market-limit-distribution-excluded-successfully": "¡Distribución de límite excluida con éxito!",
  "market-bank-account-registered-successfully": "¡Cuenta bancaria registrada con éxito!",
  "market-limit-distribution-registered-successfully": "¡Distribución de límite registrada con éxito!",
  "market-limit-distribution-updated-successfully": "¡Distribución de límite actualizada con éxito!",
  "market-choose-financial-institutions": "Elija las Instituciones Financieras",
  "market-shared-folder-success": "¡Carpeta compartida con éxito!",
  "market-bank-accounts-list": "Lista de Cuentas Bancarias",
  "market-edit-bank-account": "Editar Cuenta Bancaria",
  "market-company-documents": "Documentos de la empresa",
  "market-company-files": "Archivos de la empresa",
  "market-link-copied-to-clipboard": "Enlace copiado al portapapeles",
  "market-share-with-financial-institutions": "Compartir con todas las instituciones financieras",
  "market-select-at-least-one-bank": "Seleccione al menos un banco",
  "market-download-selected": "Descargar Seleccionados",
  "market-no-financial-institutions-registered1": "No hay instituciones financieras registradas.",
  "market-register-new-bank-relationship": "Registrar Nueva Relación Bancaria",
  "market-add-limit-distribution": "Agregar Distribución de Límite",
  "market-digit": "dígito",
  "negotiation-credit-pipeline": "Pipeline de Crédito",
  "negotiation-negotiations-in-progress": "Negociaciones en Curso",
  "negotiation-new-negotiation": "Nueva negociación",
  "negotiation-select-company-to-view-current-negotiations": "Seleccione una empresa para ver las negociaciones en curso",
  "negotiation-add-negotiation": "Agregar Negociación",
  "negotiation-reference-name1": "Nombre de Referencia",
  "negotiation-reason-for-negotiation": "Motivo de la Negociación",
  "negotiation-next-action-required": "Siguiente acción requerida",
  "negotiation-task-created-successfully": "Tarea creada con éxito",
  "negotiation-error-creating-task": "Error al crear tarea",
  "negotiation-comment-created-successfully": "Comentario creado con éxito",
  "negotiation-error-creating-comment": "Error al crear comentario",
  "negotiation-document-created-successfully": "Documento creado con éxito",
  "negotiation-error-creating-document": "Error al crear el documento",
  "negotiation-negotiation-successfully-created": "Negociación creada con éxito",
  "negotiation-error-creating-negotiation": "Error al crear negociación",
  "negotiation-negotiation-successfully-updated": "Negociación actualizada con éxito",
  "negotiation-error-updating-negotiation": "Error al actualizar la negociación",
  "negotiation-priority-changed-successfully": "¡Prioridad cambiada con éxito!",
  "negotiation-error-changing-negotiation-priority": "Error al cambiar la prioridad de la negociación",
  "negotiation-negotiation-successfully-deleted": "",
  "negotiation-negotiation-removed-successfully": "Negociación eliminada con éxito",
  "negotiation-remove-negotiation": "¿Eliminar negociación?",
  "negotiation-confirm-remove-negotiation": "¿Está seguro de que desea eliminar la negociación?",
  "negotiation-comment-deleted-successfully": "Comentario eliminado con éxito",
  "negotiation-task-deleted-successfully": "Tarea eliminada con éxito",
  "onboarding-onboarding": "Onboarding",
  "onboarding-company-registration": "Registro de empresa",
  "onboarding-company-registration-subtitle": "Registrar y enviar los documentos de su empresa es fundamental para que podamos realizar un análisis detallado. Esto nos permitirá trabajar con los bancos, garantizando eficiencia y precisión en todas las etapas de las soluciones financieras para su negocio.",
  "onboarding-progress": "Onboarding",
  "onboarding-company-information": "Información de la empresa",
  "onboarding-contacts": "Contactos",
  "onboarding-document-upload": "Carga de documentos",
  "onboarding-uploading-general-documents": "Cargando documentos generales",
  "onboarding-uploading-billing-documents": "Cargar documentos de facturación",
  "onboarding-uploading-financial-statements": "Subir estados financieros",
  "onboarding-uploading-projects": "Subiendo proyectos",
  "onboarding-uploading-warranty-documents": "Cargar documentos de garantía",
  "onboarding-sector": "Sector",
  "onboarding-do-onboarding": "Hacer onboarding",
  "onboarding-onboarding-completed-successfully": "Onboarding se completó con éxito",
  "onboarding-onboarding-saved-successfully": "Onboarding se guardó correctamente.",
  "onboarding-onboarding-updated": "Onboarding actualizado",
  "onboarding-error-updating-onboarding": "Error al actualizar la incorporación",
  "onboarding-company-contact-persons": "Personas de contacto de la empresa",
  "onboarding-accounting-contact-persons": "Personas de contacto de la cuenta",
  "onboarding-financial-contact-persons": "Personas de contacto financiero",
  "onboarding-area-position": "Área/Posición",
  "onboarding-social-contract-contractual-changes": "Contrato social y cambios contractuales",
  "onboarding-documentation-legal-representatives": "Documentación de representantes legales",
  "onboarding-income-tax-partners": "Impuesto sobre la renta de los socios",
  "onboarding-corporate-structure-map": "Mapa de estructura corporativa",
  "onboarding-executive-organizational-chart": "Organigrama ejecutivo",
  "onboarding-have-holding-company": "¿Tiene una sociedad holding?",
  "onboarding-financial-statements-last3years": "Estados financieros (últimos 3 años)",
  "onboarding-invalid-file-max-size": "Archivo no válido. Seleccione un archivo .pdf o .xlsx de hasta 100 MB.",
  "onboarding-pdf-or-xlsx-files-up-to100-mb": "Archivos .pdf o .xlsx de hasta 100 MB",
  "onboarding-pdf-files-up-to100-mb": "Archivos .pdf de hasta 100 MB",
  "onboarding-pdf-xlsx-or-image-files-up-to100-mb": "Archivos .pdf, .xlsx o imagen (.jpg, .png) de hasta 100 MB",
  "onboarding-pdf-xlsx-or-pptx-files-up-to100-mb": "Archivos .pdf, .xlsx o .pptx de hasta 100 MB",
  "onboarding-xlsx-files-up-to100-mb": "Archivos .xlsx de hasta 100 MB",
  "onboarding-jpg-or-png-files-up-to100-mb": "Archivos .jpg o .png de hasta 100 MB",
  "onboarding-pdf-or-pptx-files-up-to100-mb": "Archivos .pdf o .pptx de hasta 100 MB",
  "onboarding-pptx-files-up-to100-mb": "Archivos .pptx de hasta 100 MB",
  "onboarding-required": "Obligatorio",
  "onboarding-optional": "Deseable",
  "onboarding-invalid-file": "Archivo no válido",
  "onboarding-select-pd-xlsx-file-up100-mb": "Seleccione un archivo .pdf o .xlsx de hasta 100 MB",
  "onboarding-market-studies": "Estudios de mercado",
  "onboarding-institutional-presentation": "Presentación institucional",
  "onboarding-commercial-presentations": "Presentaciones comerciales",
  "onboarding-presentations-information-products-services": "Presentaciones e información sobre productos y servicios",
  "onboarding-company-images-products-services": "Imágenes, productos y servicios de la empresa",
  "onboarding-brand-manual": "manual de marca",
  "onboarding-logos-vector-jpg-png-formats": "Logotipos en formatos vectorial, JPG y PNG",
  "onboarding-brand-pitch-deck": "Presentación de marca",
  "onboarding-annual-billing": "Facturación Anual",
  "onboarding-partial-billing-current-year": "Facturación parcial año en curso",
  "onboarding-balance-sheet-income-statement-ddc": "Balance, cuenta de resultados y DFC",
  "onboarding-monthly-balance-sheets-last3-years": "Balances mensuales de los últimos 3 años",
  "onboarding-business-plan": "Plan de negocios",
  "onboarding-projections": "Proyecciones",
  "onboarding-multi-year-financial-projection": "Proyección financiera plurianual",
  "onboarding-backlog-with-balance-projection": "Cartera con balance y proyección",
  "onboarding-debt": "Deuda",
  "onboarding-debt-projection": "Proyección de deuda",
  "onboarding-edital": "Aviso",
  "onboarding-loan-agreements": "Acuerdos de préstamo",
  "onboarding-physical-financial-schedule": "Calendario físico-financiero",
  "onboarding-consortium-incorporation-document-ia": "Documento de constitución del consorcio (si aplica)",
  "onboarding-general-information-sae": "Información general (estudios, análisis, etc...)",
  "onboarding-properties-registrations-evaluations": "Propiedades: inscripciones y valoraciones",
  "onboarding-accounts-receivable-cdmr": "Cuentas por cobrar (consentimiento, plazo, medio de recepción...)",
  "onboarding-contracts-customers": "Contratos con clientes",
  "onboarding-send-onboarding": "Enviar onboarding",
  "onboarding-send-link": "Enviar enlace",
  "onboarding-choose-user-to-send-onboarding-link": "Elija el usuario para enviar el enlace de incorporación",
  "onboarding-error-sending-onboarding-link": "Error al enviar el enlace de incorporación",
  "onboarding-registration-completed": "Registro completado",
  "onboarding-invitation-to-user-by-company-success": "Se ha enviado la invitación al usuario {{ email }}, recibirá un correo electrónico para validar los datos y una vez finalizado le avisaremos del estado.",
  "onboarding-file-upload-success": "¡Archivo subido con éxito!",
  "onboarding-company-documents1": "Documentos de la Empresa",
  "onboarding-general-documents1": "Documentos Generales",
  "onboarding-billing-documents1": "Documentos de Facturación",
  "onboarding-financial-statements1": "Estados Financieros",
  "onboarding-projects1": "Proyectos",
  "onboarding-warranty-documents1": "Documentos de Garantía",
  "onboarding-document-analysis2": "Análisis de Documentos",
  "onboarding-mandatory-documents-submitted": "Todos los documentos obligatorios enviados",
  "onboarding-documents-pending-delivery": "Hay documentos pendientes de envío",
  "onboarding-all-documents-approved": "Todos los documentos aprobados",
  "onboarding-documents-not-approved": "Documentos enviados aún no aprobados",
  "onboarding-no-document-sent": "Ningún documento enviado",
  "onboarding-approved1": "Aprobado",
  "onboarding-request-rejected": "Rechazado",
  "onboarding-pending-analysis": "Pendiente de análisis",
  "onboarding-analyzed-by-user": "Analizado por {user} en {date}",
  "onboarding-sent-by-user-on-date": "Enviado por {user} el {date}",
  "onboarding-annual-revenue-previous-years": "Ingresos Anuales (Años Anteriores)",
  "onboarding-balance-dre-dfc-previous-years": "Balance, DRE y DFC (Años Anteriores)",
  "risk-panel-currency-expiration": "Moneda / Vencimiento",
  "risk-panel-future-value-brazilian-real": "Valor Futuro (BRL)",
  "risk-panel-weighted-capital": "Capital Ponderado",
  "risk-panel-effective-current-loss-cap-brl": "Pérdida Efectiva Actual CAP (BRL)",
  "risk-panel-loss-percentage-current": "Pérdida % Actual",
  "risk-panel-scenario-brl": "Escenario (BRL)",
  "risk-panel-average-weighted-cost": "Costo Ponderado Medio",
  "risk-panel-partial-hedge-economy": "Economía de Cobertura Parcial",
  "risk-panel-cap-exhibition": "Exposición del CAP",
  "risk-panel-monthly-exhibition": "Exposición mensual",
  "risk-panel-average-spot-ref": "Promedio de Spot Ref.",
  "risk-panel-average-price": "Precio Promedio",
  "risk-panel-average-total-cost": "Costo Total Promedio",
  "risk-panel-partial-hedge-economy-brl": "Hedge parcial economía BRL",
  "risk-panel-average-cost-perfect-hedge": "Costo Promedio de Cobertura Perfecta",
  "risk-panel-average-margin-cap": "Promedio de Margen CAP",
  "risk-panel-current-parity": "Paridad Actual",
  "risk-panel-current-actual-loss-cap": "CAP de Pérdida Actual",
  "risk-panel-current-loss": "Pérdida Actual",
  "risk-panel-loss1": "Pérdida",
  "risk-panel-future-due-dates": "Fechas de Vencimiento Futuras",
  "risk-panel-passive-future-due-dates": "Fechas de Vencimiento Futuras Pasivas",
  "risk-panel-realized-economy": "Economía Realizada",
  "risk-panel-estimated-economy": "Economía Estimada",
  "risk-panel-synthetic-vision": "Visión Sintética",
  "risk-panel-total-volume": "Volumen total",
  "risk-panel-net-result": "resultado neto",
  "risk-panel-partial-hedge-economics": "Economía de cobertura parcial",
  "risk-panel-average-term-in-days": "plazo medio en días",
  "risk-panel-current-loss-and-percentage": "Pérdida actual y %",
  "risk-panel-annual-hedge-cost": "Costo anual del hedge",
  "risk-panel-total-amount-and-protected-amount": "Cantidad total y cantidad protegida",
  "risk-panel-estimated-economy1": "economía estimada",
  "risk-panel-future-value-vs-cap-vs-spot": "Valor futuro a vencimiento vs CAP vs SPOT",
  "risk-panel-current-loss-estimate-vs-scenarios": "Estimación de pérdida actual vs Escenarios",
  "risk-panel-total-general-brl": "Total General BRL",
  "risk-panel-company-parity": "Empresa/Paridad",
  "risk-panel-margin-of-cap-percentage": "Margen del CAP (%)",
  "risk-panel-future-value-brl": "Valor Futuro (BRL)",
  "risk-panel-spot-ref1": "Referencia del lugar.",
  "risk-panel-price-ndf": "Precio (NDF)",
  "risk-panel-total-cost-yearly-percentage": "Costo Total (anual) (%)",
  "risk-panel-partial-hedge-economy-brl1": "Economía BRL Cobertura parcial (%)",
  "risk-panel-perfect-cost-brl": "Costo Perfecto (BRL)",
  "risk-panel-margin-cap-percentage": "Margen CAP (%)",
  "risk-panel-current-parity1": "Paridad Actual",
  "risk-panel-usd-pricing": "Precio en USD",
  "risk-panel-current-effectively-lost-cap-brl": "Pérdida Efectiva Actual CAP (BRL)",
  "risk-panel-current-loss-percentage": "Pérdida Actual (%)",
  "risk-panel-loss-scenario": "Escenario de pérdida",
  "risk-panel-current-effective-loss-cap-pec": "Pérdida Efectiva Actual CAP (PEC)",
  "risk-panel-partial-hedge-economy-brl2": "Economía de cobertura parcial (BRL)",
  "risk-panel-value-brazilian-reais-thousands": "Valor (Miles de BRL)",
  "risk-panel-amount-not-protected": "Monto no protegido",
  "risk-panel-protected-amount1": "cantidad protegida",
  "risk-panel-weighted-average": "capital ponderado",
  "risk-panel-currency-fluctuation-sensitivity-slider": "Utiliza este control deslizante para ajustar la sensibilidad de las fluctuaciones de divisas",
  "risk-panel-sensitivity-parameters-visibility": "Aquí puedes ver los parámetros de sensibilidad.",
  "risk-panel-exchange-rates-and-variations": "Aquí están las tasas de cambio y sus variaciones.",
  "risk-panel-select-desired-currency-pair-here": "Seleccione el par de monedas deseado aquí.",
  "risk-panel-operation-type-choice-comex-loan": "Elija el tipo de operación entre COMEX y préstamo.",
  "risk-panel-annual-hedge-cost-percentage1": "Informe el costo anual de cobertura en porcentaje.",
  "risk-panel-estimated-annual-economy": "Economía Anual Estimada",
  "risk-panel-no-operations-for-selected-filters": "No hay operaciones para los filtros seleccionados",
  "risk-panel-passive-future-expirations-id": "ID de la Operación",
  "risk-panel-value-local-currency-input": "Entrada (BRL)",
  "risk-panel-value-local-currency-output": "Salida (BRL)",
  "risk-panel-conversion-tax": "Tasa de Conversión",
  "risk-panel-variation": "Variación (%)",
  "user-permission-insert": "Insertar",
  "user-permission-save": "Ahorrar",
  "user-permission-cancel": "Cancelar",
  "user-permission-delete": "Borrar",
  "user-permission-update": "Actualizar",
  "user-permission-no-group-registered": "No hay grupos registrados",
  "user-users": "Usuarios",
  "user-administration": "Administración",
  "user-all": "Todo",
  "user-active": "Activo",
  "user-inactive": "Inactivo",
  "user-disabled": "Desactivado",
  "user-pending": "Pendiente",
  "user-actives": "Activo",
  "user-inactives": "Inactivo",
  "user-disableds": "Desactivado",
  "user-pendings": "Pendiente",
  "user-no-profile-registered": "Ningún perfil registrado",
  "user-to-add": "Agregar",
  "user-add-user": "Agregar usuario",
  "user-edit-user": "Editar usuario",
  "user-cancel": "Cancelar",
  "user-finish": "Finalizar",
  "user-information": "Información",
  "user-user-type": "Tipo de usuario",
  "user-name": "Nombre",
  "user-first-name": "Primer nombre",
  "user-second-name": "Segundo nombre",
  "user-lastname": "Apellido",
  "user-function": "Función",
  "user-profile": "Perfil",
  "user-email": "Correo electrónico",
  "user-phone": "Teléfono",
  "user-type": "Tipo",
  "user-localization": "Ubicación",
  "user-language": "Idioma",
  "user-date-format": "Formato de fecha",
  "user-time-format": "Formato de tiempo",
  "user-timezone": "Huso horario",
  "user-status": "Status",
  "user-select": "Seleccionar",
  "user-permissions-group": "Grupo de permisos",
  "user-selected": "seleccionado",
  "user-mark-all": "Todos",
  "user-new-group": "Nuevo grupo",
  "user-permissions": "Permisos",
  "user-tenant": "Tenant",
  "user-group-created-successfully": "Grupo de usuarios creado exitosamente",
  "user-group-updated-successfully": "Grupo de usuarios actualizado correctamente",
  "user-group-deleted-successfully": "Grupo de usuarios eliminado correctamente",
  "user-user-created-successfully": "Usuario creado exitosamente",
  "user-user-updated-successfully": "Usuario actualizado correctamente",
  "user-user-deleted-successfully": "Usuario eliminado correctamente",
  "user-user-title-delete-confirmation": "¿Estás seguro de que deseas eliminar este usuario?",
  "user-user-description-delete-confirmation": "El usuario perderá todo acceso al sistema.",
  "user-user-group-title-delete-confirmation": "¿Estás seguro de que deseas eliminar este grupo?",
  "user-user-group-description-delete-confirmation": "El grupo será eliminado del sistema.",
  "user-user-error-loading-users": "Error al cargar usuarios",
  "user-user-error-loading-user": "Error al cargar usuario",
  "user-user-error-removing-user": "Error al eliminar usuario",
  "user-user-error-loading-groups": "Error al cargar grupos",
  "user-user-error-loading-group": "Error al cargar grupo",
  "user-user-error-removing-group": "Error al eliminar grupo",
  "user-user-error-loading-roles": "Error al cargar roles",
  "user-user-error-loading-role": "Error al cargar rol",
  "user-user-error-removing-role": "Error al eliminar rol",
  "user-user-error-loading-languages": "Error al cargar idiomas",
  "user-user-error-loading-date-formats": "Error al cargar formatos de fecha",
  "user-user-error-loading-time-formats": "Erro al cargar formatos de tiempo",
  "user-user-error-loading-timezones": "Error al cargar husos horarios",
  "user-user-error-loading-permissions": "Error al cargar permisos",
  "user-user-error-loading-permission": "Error al cargar permiso",
  "user-user-error-removing-permission": "Error al eliminar permiso",
  "user-user-error-creating-user": "Error al crear usuario",
  "user-user-error-updating-user": "Error al actualizar usuario",
  "user-user-error-creating-permissions-group": "Error al crear grupo de permisos",
  "user-user-error-updating-permissions-group": "Error al actualizar grupo de permisos",
  "user-user-error-removing-permissions-group": "Error al eliminar grupo de permisos",
  "user-permissions-group-removed-successfully": "Grupo de permisos eliminado con éxito",
  "user-change": "Cambiar",
  "user-no-user-found": "Ningún usuario encontrado",
  "user-manage-users": "Gestionar Usuarios",
  "user-last-login": "Último Acceso",
  "user-has-password": "Tiene Contraseña",
  "validation-enter-valid-email": "Por favor, introduce un correo electrónico válido",
  "validation-field-required": "Este campo es obligatorio",
  "validation-field-error": "Error en el campo",
  "validation-minlength": "La longitud mínima permitida es de {0} caracteres",
  "validation-maxlength": "La longitud máxima permitida es de {0} caracteres",
  "validation-password-mismatch": "Las contraseñas no coinciden"
}
